import React from 'react';
import { MsgIcon } from '../../uiComponents/icons';
import { useTranslation } from 'react-i18next';

const Comments = ({ text, event }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'components.comments' });

  // Some comments arrive as "reason | note" (e.g. cancellations). Split into
  // the main reason and an optional note; tolerate text without a pipe.
  const [reason, ...rest] = (text ?? '').split('|');
  const note = rest.join('|').trim();

  return (
    <div className='d-flex flex-column w-100' style={{ color: '#687385' }}>
      <div className=' w-100 d-flex justify-content-start align-items-center'>
        <MsgIcon size='12px' />
        <div className='ml-2 font-weight-light'>
          {event === 'TABLE_ASSIGNED' ? t('tableNumber') : t('title')}
        </div>
      </div>

      <div className='ml-3 font-italic font-weight-semibold'>{reason.trim()}</div>
      {note && <div className='ml-3 font-weight-light'>{note}</div>}
    </div>
  );
};

export default Comments;
